<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
import { accountSetup } from '@/services/login.service';
import axios from 'axios';
import SocketioService from '@/services/socketio.service.js';
import Vue from 'vue';

export default {
	name: 'App',
	components: {},
	created() {
		this.$store.dispatch('initDarkMode');
		if (!this.$route.meta.nocheck) {
			if (localStorage.getItem('token')) {
				this.$store.state.token = localStorage.getItem('token');
			}

			axios.defaults.headers.common['x-access-token'] = this.$store.state.token;
			axios.defaults.headers.common['x-access-token'] = this.$store.state.token;

			this.$store.state.account_setup = true;
			this.$store.commit('set_loading_page', 'setup');

			this.$store.socket = SocketioService;
			this.$store.socket.setupSocketConnection(
				Vue.prototype.$apiBase.replace('/api', '')
			);
			//this.$store.socket.sendRSelectRemark
			accountSetup()
				.then((d) => {
					//console.log("d", d)
					if (d.data.name) {
						this.$store.state.name = d.data.name;
					}
					if (d.data.login_system) {
						this.$store.state.login_system = d.data.login_system;
					}
					if (d.data.userId) {
						this.$store.state.userId = d.data.userId;
					}

					if (d.data.userUid) {
						this.$store.state.user_uid = d.data.userUid;
					}

					if (d.data.company) {
						this.$store.state.company = d.data.company;
					}

					let newTestProject = JSON.parse(
						JSON.stringify(this.$store.state.testProject)
					);

					if (d.data.userId && !d.data.old_testproject) {
						newTestProject.projectId = '00000000' + d.data.userId;
						newTestProject._id = '00000000' + d.data.userId;
						newTestProject.uid = '00000000' + d.data.userId;
						newTestProject.projectnumber = '00000000' + d.data.userId;
					}

					if (d.data.projects) {
						d.data.projects.push(newTestProject);
						this.$store.commit('set_projects', d.data.projects);
					} else {
						this.$store.commit('set_projects', [newTestProject]);
					}

					if (d.data.account_role) {
						this.$store.state.account_role = d.data.account_role;
					}

					if (d.data.dm_rolle !== undefined) {
						this.$store.commit('set_dm_rolle', d.data.dm_rolle);
					}
					if (d.data.dm_berechtigungen) {
						this.$store.commit('set_dm_berechtigungen', d.data.dm_berechtigungen);
					}

					this.$store.commit('set_account_setup_done', true);
					this.$store.commit('set_loading_page', null);
				})
				.catch((e) => {
					this.$store.commit('set_account_setup_done', true);
					this.$store.dispatch('api_error', e);
				});
		}
	},
};
</script>

<style>
/* Allow content to use more horizontal space on wide screens */
@media (min-width: 1280px) {
	.wide-xl {
		max-width: 1440px !important;
	}
}
@media (min-width: 1660px) {
	.wide-xl {
		max-width: 1760px !important;
	}
}
@media (min-width: 1920px) {
	.wide-xl {
		max-width: 95% !important;
	}
}

/* Tables: white card background to stand out from gray page background */
.table,
.dm-table,
.dm-table-wrap,
.dm-dash-table {
	background-color: #fff;
	border-radius: 6px;
	overflow: hidden;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.dark-mode .table {
	background-color: #1a2332;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.dark-mode .dm-table,
.dark-mode .dm-table-wrap,
.dark-mode .dm-dash-table {
	background-color: transparent !important;
	box-shadow: none !important;
}

@media only screen and (max-width: 760px) {
	.hide-mobile {
		display: none;
	}
}

/* Dark Mode Overrides - component-specific (general overrides in custom-theme.css) */

.dark-mode .imgupload-conteiner {
	background-color: #1e2a3a;
	border-color: #3c4d62;
}

/* ReportV3 Dark Mode */
.dark-mode .card.card-preview {
	background-color: #1a2332;
	border-color: #3c4d62;
}

.dark-mode .chapter-column {
	background-color: #141c26 !important;
}

.dark-mode .content-column {
	background-color: #1a2332;
}

.dark-mode .lang-toggle {
	background: #1e2a3a !important;
	border-color: #3c4d62 !important;
	color: #b6c6e3 !important;
}

.dark-mode .nav-sidebar-toggle-btn {
	background: #1e2a3a !important;
	border-color: #3c4d62 !important;
	color: #b6c6e3 !important;
}

.dark-mode .nav-sidebar-toggle-btn:hover {
	background: #253345 !important;
}

.dark-mode .shortcut-modal {
	background: #1a2332 !important;
	border: 1px solid #3c4d62 !important;
}

.dark-mode .shortcut-header {
	border-color: #3c4d62 !important;
	color: #b6c6e3;
}

.dark-mode .shortcut-header h5 {
	color: #fff;
}

.dark-mode .shortcut-header .btn {
	color: #b6c6e3;
}

.dark-mode .shortcut-body {
	background: #1a2332 !important;
	color: #b6c6e3;
}

.dark-mode .shortcut-body kbd {
	background: #141c26;
	color: #b6c6e3;
	border-color: #3c4d62;
}

.dark-mode .status-filter-bar {
	border-color: #3c4d62;
}

.dark-mode .status-filter-btn {
	background: #1e2a3a;
	border-color: #3c4d62;
	color: #b6c6e3;
}

.dark-mode .table {
	color: #b6c6e3;
}

.dark-mode .table thead th {
	border-color: #3c4d62;
	color: #b6c6e3;
}

.dark-mode .table td,
.dark-mode .table th {
	border-top-color: #3c4d62;
	border-bottom-color: #3c4d62;
}

.dark-mode .breadcrumb {
	background-color: transparent;
}

.dark-mode .breadcrumb-item a {
	color: #E8751A;
}

.dark-mode .form-control {
	background-color: #1e2a3a;
	border-color: #3c4d62;
	color: #b6c6e3;
}

.dark-mode .form-control::placeholder {
	color: #8094ae;
}

.dark-mode .breadcrumb-container {
	background-color: #141c26 !important;
	border-bottom: 1px solid #3c4d62 !important;
}

.dark-mode .breadcrumb-container .breadcrumb-item.active {
	color: #fff !important;
}

.dark-mode .breadcrumb-container .breadcrumb-item + .breadcrumb-item::before {
	color: #8094ae;
}

.dark-mode .preview-block {
	background-color: #1a2332 !important;
}

.dark-mode .container-col1,
.dark-mode .content-col1 {
	background-color: #1a2332 !important;
}

.dark-mode .insection_selected {
	background-color: #2d3f54 !important;
}

.dark-mode .findings-table-container {
	background-color: #1a2332 !important;
	border-color: #3c4d62 !important;
}

.dark-mode .findings-table .sticky-header {
	background: #1a2332 !important;
}

.dark-mode .findings-table .sticky-header th {
	color: #b6c6e3;
	border-color: #3c4d62 !important;
}

/* Modal Dark Mode */
.dark-mode .modal-content {
	background-color: #1a2332 !important;
	border-color: #3c4d62 !important;
}

.dark-mode .modal-header {
	border-color: #3c4d62 !important;
}

.dark-mode .modal-header .modal-title {
	color: #b6c6e3;
}

.dark-mode .modal-header .close {
	color: #b6c6e3;
}

.dark-mode .modal-body {
	color: #b6c6e3;
}

.dark-mode .modal-footer {
	border-color: #3c4d62 !important;
}

.dark-mode .modal-footer.bg-light {
	background-color: #141c26 !important;
}

.dark-mode .finding-preview {
	background: #141c26 !important;
	border-color: #3c4d62 !important;
}

.dark-mode .finding-text {
	color: #b6c6e3 !important;
}

.dark-mode .comments-section {
	border-color: #3c4d62 !important;
}

.dark-mode .comment-item {
	border-color: #3c4d62 !important;
}

.dark-mode .comment-author {
	color: #fff !important;
}

.dark-mode .comment-text {
	color: #b6c6e3 !important;
}

.dark-mode .add-comment-section {
	border-color: #3c4d62 !important;
}

.dark-mode textarea.form-control {
	background-color: #1e2a3a !important;
	border-color: #3c4d62 !important;
	color: #b6c6e3 !important;
}

.dark-mode .text-muted {
	color: #8094ae !important;
}

.dark-mode .icon-bg {
	background-color: #141c26 !important;
}

/* Login Page Dark Mode */
.dark-mode .card.card-bordered {
	background-color: #1a2332 !important;
	border-color: #3c4d62 !important;
}

.dark-mode .nk-block-title {
	color: #fff;
}

.dark-mode .nk-block-des p {
	color: #b6c6e3;
}

.dark-mode .form-label {
	color: #b6c6e3;
}

.dark-mode select.form-control {
	background-color: #1e2a3a !important;
	border-color: #3c4d62 !important;
	color: #b6c6e3 !important;
}

/* Loading Overlay Dark Mode */
.dark-mode .vld-background {
	background: #0d1520 !important;
	opacity: 0.85 !important;
}

/* DM Module Dark Mode */
.dark-mode .dm-table thead {
	background: #141c26 !important;
	border-bottom-color: #3c4d62 !important;
}

.dark-mode .dm-table-th {
	color: #8094ae !important;
}

.dark-mode .dm-table-th:hover {
	color: #b6c6e3 !important;
}

.dark-mode .dm-table tbody td {
	border-bottom-color: #3c4d62 !important;
	color: #b6c6e3 !important;
}

.dark-mode .dm-table-row:hover {
	background: #1e2a3a !important;
}

.dark-mode .table-row:hover {
	background-color: #1e2a3a !important;
}

.dark-mode .table-striped tbody tr:nth-of-type(odd) {
	background-color: rgba(255, 255, 255, 0.03);
}

.dark-mode .table-striped tbody tr:hover {
	background-color: #1e2a3a !important;
}

/* DM Dashboard */
.dark-mode .kz-chip {
	background: #1a2332 !important;
	border-color: #3c4d62 !important;
}

.dark-mode .kz-chip:hover {
	border-color: #6576ff !important;
}

.dark-mode .kz-icon-wrap {
	background: #1e2a3a !important;
}

.dark-mode .kz-value {
	color: #fff !important;
}

.dark-mode .kz-label {
	color: #8094ae !important;
}

.dark-mode .kz-sub {
	color: #8094ae !important;
}

.dark-mode .dm-select {
	color: #b6c6e3 !important;
}

.dark-mode .ampel-card {
	background: #1e2a3a !important;
}

.dark-mode .ampel-card:hover {
	background: #253345 !important;
}

/* DM Dokumente */
.dark-mode .datei-link {
	color: #b6c6e3 !important;
}

.dark-mode .datei-link:hover {
	color: #E8751A !important;
}

.dark-mode .btn-icon-action {
	color: #8094ae !important;
}

.dark-mode .btn-icon-action:hover {
	background: #1e2a3a !important;
	color: #E8751A !important;
}

/* DM Anlagen Import */
.dark-mode .import-stat {
	background: #1e2a3a !important;
}

.dark-mode .import-stat-success {
	background: rgba(36, 196, 95, 0.1) !important;
}

.dark-mode .import-stat-info {
	background: rgba(232, 117, 26, 0.1) !important;
}

.dark-mode .import-stat-value {
	color: #fff !important;
}

.dark-mode .import-stat-label {
	color: #8094ae !important;
}

.dark-mode .badge-secondary {
	background: #3c4d62 !important;
	color: #b6c6e3 !important;
}

/* DM Adressen Rollen-Pills */
.dark-mode .rolle-pill {
	background: #1e2a3a !important;
	border-color: #3c4d62 !important;
	color: #b6c6e3 !important;
}

.dark-mode .rolle-pill:hover {
	border-color: #E8751A !important;
	background: rgba(232, 117, 26, 0.08) !important;
}

.dark-mode .rolle-pill-active {
	border-color: #E8751A !important;
	background: rgba(232, 117, 26, 0.12) !important;
	color: #E8751A !important;
}

.dark-mode .rolle-pill .icon {
	color: #8094ae !important;
}

.dark-mode .rolle-pill-active .icon {
	color: #E8751A !important;
}

.dark-mode .dm-status-unconfirmed {
	background-color: #3c4d62 !important;
}

/* DM Preislisten position cards */
.dark-mode .preview-hr {
	border-color: #3c4d62;
}

.dark-mode .overline-title-alt {
	color: #8094ae !important;
}

.dark-mode .nav-tabs .nav-link {
	color: #8094ae !important;
}

.dark-mode .nav-tabs .nav-link.active {
	color: #E8751A !important;
	background: transparent !important;
	border-bottom-color: #E8751A !important;
}

.dark-mode .mastr-key {
	color: #8094ae !important;
}

.dark-mode .custom-control-label {
	color: #b6c6e3;
}
</style>
